// Development URL (local)
const DEV_API_URL = 'http://localhost:5000/api';

// Production URL (Vercel)
const PROD_API_URL = 'https://mikan-backend.vercel.app/api';

// Export the appropriate URL based on environment
export const API_URL = PROD_API_URL;  // Always use Vercel URL for now

// Auth endpoints
export const AUTH_ENDPOINTS = {
    login: `${API_URL}/auth/login`,
    register: `${API_URL}/auth/register`
};

// Project endpoints
export const PROJECT_ENDPOINTS = {
    getAllProjects: `${API_URL}/projects`,
    createProject: `${API_URL}/projects`,
    updateProject: (id) => `${API_URL}/projects/${id}`,
    deleteProject: (id) => `${API_URL}/projects/${id}`
};

// Career endpoints
export const CAREER_ENDPOINTS = {
    getAllCareers: `${API_URL}/careers`,
    createCareer: `${API_URL}/careers`,
    updateCareer: (id) => `${API_URL}/careers/${id}`,
    deleteCareer: (id) => `${API_URL}/careers/${id}`,
    applyForCareer: `${API_URL}/careers/apply`
}; 